module.exports = __webpack_public_path__ + "img/betterPracticesBG.1456ad5b.png";